import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { setTenant } from './theme/tokens';
import { ThemeProvider } from './theme/react';
import tenantConfig from './tenant.config';
// Apply tenant BEFORE any mock/fixture module evaluates, so module-scope
// reads of `getTenant()` pick up the configured currency/locale.
setTenant(tenantConfig);
// Dynamic import so the static import graph of App (and its transitive
// mock fixtures) doesn't execute until after setTenant() above has run.
void import('./app/App').then(({
  App
}) => {
  const container = document.getElementById('root');
  const root = createRoot(container!);
  root.render(<ThemeProvider defaultTheme="rabbit" availableThemes={['rabbit', 'pomelo', 'dark']} data-id="element-14205">
      <App data-id="element-14206" />
    </ThemeProvider>);
});